import PropTypes from "prop-types"

import { TransactionTypeEnumKeys } from "./TransactionTypeEnum"

const properties = {
  amount: PropTypes.number.isRequired,
  investedAmount: PropTypes.number.isRequired,
  investmentId: PropTypes.string.isRequired,
  investmentName: PropTypes.string,
  investorAccountId: PropTypes.string.isRequired,
  returnRate: PropTypes.number.isRequired,
  tierId: PropTypes.string.isRequired,
  transactionType: PropTypes.oneOf(TransactionTypeEnumKeys).isRequired
}

const ScheduleDistributionShape = PropTypes.exact(properties)

export default ScheduleDistributionShape
export { properties }
